import {createGate} from 'effector-react';

import {
    fetchDocumentCommissioningCreate,
    fetchDocumentDropOutCreate,
    fetchDocumentGtinInfo,
    fetchDocumentMovingCreate,
    fetchDocumentUPDCreate,
} from 'api/documents';
import {fetchDocumentUtilisationCreate} from 'api/documents/utilisation';
import {rootDomain} from 'core/rootDomain';
import {CommissioningFormData, DropOutFormData, MovingFormData, UtilisationFormData} from 'types';

import {CodeResponseType} from 'types/validation';

const domain = rootDomain.createDomain('DocumentsListDomain');
export const DocumentsCreateGate = createGate('DocumentsCreateGate');
export const DocumentCreatePreviewGate = createGate('DocumentCreatePreviewGate');

export const sendDropOutFx = domain.createEffect({
    name: 'sendDropOutFx',
    handler: fetchDocumentDropOutCreate,
});
export const sendUtilisationFx = domain.createEffect({
    name: 'sendUtilisationFx',
    handler: fetchDocumentUtilisationCreate,
});
export const sendCommissioningFx = domain.createEffect({
    name: 'sendCommissioningFx',
    handler: fetchDocumentCommissioningCreate,
});
export const sendUPDFx = domain.createEffect({
    name: 'sendUPDFx',
    handler: fetchDocumentUPDCreate,
});

export const sendMovingFx = domain.createEffect({
    name: 'sendMovingFx',
    handler: fetchDocumentMovingCreate,
});

export const fetchGtinInfoFx = domain.createEffect({
    name: 'fetchGtinInfoFx',
    handler: fetchDocumentGtinInfo,
});

export const createDropOutDocument = domain.createEvent();
export const createUtilisationDocument = domain.createEvent();
export const createCommissioningDocument = domain.createEvent();
export const createMovingDocument = domain.createEvent();

export const showBatchNumberModal = domain.createEvent<boolean>();
export const batchNumberModal$ = domain.createStore(false);

export const dropOutFormChanged = domain.createEvent<DropOutFormData>();
export const dropOutForm$ = domain.createStore<DropOutFormData>({
    documentId: '',
    reason: '',
    salesChannel: '',
    supportingDocumentNumber: '',
    supportingDocumentDate: null,
    comment: '',
    attachmentFiles: [],
    counterpartyId: '',
    counterpartyName: '',
    destinationCountry: '',
    resultMarkingCodes: [],
});

export const isUtilisationGroup$ = domain.createStore(false);
export const utilisationGroupChanged = domain.createEvent<boolean>();
export const utilisationFormChanged = domain.createEvent<Partial<UtilisationFormData>>();
export const utilisationForm$ = domain.createStore<UtilisationFormData>({
    groupMarkingCode: null,
    factoryId: '',
    factoryName: '',
    productionLineId: '',
    productionLineName: '',
    applicationDate: null,
    manufacturingDate: null,
    storageLocationId: null,
    storageLocationName: '',
    batchNumber: '',
    batchNumberSource: 'auto',
});

export const commissioningFormChanged = domain.createEvent<CommissioningFormData>();
export const commissioningForm$ = domain.createStore<CommissioningFormData>({
    startCirculationDate: null,
});

export const movingFormChanged = domain.createEvent<MovingFormData>();
export const movingForm$ = domain.createStore<MovingFormData>({
    employeeFullName: '',
    storageLocationFrom: '',
    storageLocationTo: '',
    storageLocationFromId: null,
    storageLocationToId: null,
    note: '',
});

export const dataChanged = domain.createEvent<CodeResponseType['info'] | null>();
export const data$ = domain.createStore<CodeResponseType['info'][]>([]);

export const step$ = domain.createStore<number>(0);
export const stepChanged = domain.createEvent<number>();

export const fileChanged = domain.createEvent<File | undefined | null>();
export const file$ = domain.createStore<File | undefined | null>(null);

export const codes$ = domain.createStore<Array<string>>([]);
export const codesChanged = domain.createEvent<Array<string>>();

export const gtins$ = domain.createStore<any>({});

export const UPDString$ = domain.createStore<string | null>(null);
export const UPDStringChanged = domain.createEvent<string | null>();

export const lastCreatedDocumentId$ = domain.createStore<string | null>(null);
export const setLastCreatedDocumentId = domain.createEvent<string | null>();
